import React from "react";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import { Permissions } from "../utils/Permissions";
import {
  selectHasAnyDriveLicenceOutlet,
  selectDriveLicenceOutlets,
} from "../utils/identitySelectors";
import { Switch, Route } from "react-router";
import FleetSourceItem from "../components/Drive/FleetSources/FleetSourceItem";
import FleetSourcesTable from "../components/Drive/FleetSources/FleetSourcesTable";
import {
  NewDriveFleetSourceRoute,
  DriveFleetSourcesRoute,
} from "./../constants/routePaths";

export default function FleetSourcesRouting(props) {
  const { currentIdentity, resources } = props;
  return (
    <>
      <RestrictedRoute
        path={DriveFleetSourcesRoute}
        userPermissions={currentIdentity.permissions}
        routePermissions={[Permissions.AccessToDriveSettings]}
        accessAllowed={selectHasAnyDriveLicenceOutlet(currentIdentity)}
        resources={resources}
        render={(props) => {
          return (
            <FleetSourcesTable
              resources={resources}
              refreshGrid={
                props &&
                props.location &&
                props.location.state &&
                props.location.state.refreshGrid
              }
            />
          );
        }}
      />
      <Switch>
        <Route
          exact
          path={NewDriveFleetSourceRoute}
          render={(props) => (
            <FleetSourceItem
              resources={resources}
              accessibleMoboOutlets={selectDriveLicenceOutlets(currentIdentity)}
              partyId={props?.location?.state?.partyId}
              {...props}
            />
          )}
        />
        <Route
          exact
          path="/fleetsources/:fleetSourceId"
          render={(props) => (
            <FleetSourceItem
              resources={resources}
              accessibleMoboOutlets={selectDriveLicenceOutlets(currentIdentity)}
              partyId={currentIdentity.partyId}
              fleetSourceId={props.match.params.fleetSourceId}
            />
          )}
        />
      </Switch>
    </>
  );
}
